import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { MatomoService } from '../services/matomo.service';
import { ApiService } from '../services/api.service';

export const performanceInterceptor: HttpInterceptorFn = (req, next) => {
  const apiService = inject(ApiService);
  if (!req.url.startsWith(apiService.apiUrl) || req.url.includes('/admin')) {
    return next(req);
  }

  const matomo = inject(MatomoService);
  const done = matomo.timeAction('Performance', 'api-call', extractEndpointKey(req.url));

  return next(req).pipe(tap({ complete: done, error: done }));
};

function extractEndpointKey(url: string): string {
  const match = url.match(/\/backend\/([^/?]+)/);
  return match?.[1] ?? 'unknown';
}
